import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEarth: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconEarth"><Path fillRule="evenodd" clipRule="evenodd" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM9.00711 9.00495L8.00211 10.9999L4.36035 8.26983C5.74203 5.44526 8.64399 3.5 12.0003 3.5C12.7115 3.5 13.4023 3.58735 14.0626 3.75192L13.0021 7.99995L9.00711 9.00495ZM17 14.564L15.8337 17H12.3348L10.0022 13.3459L11.2957 12L13.5618 12.151L17 14.564Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEarth;
